import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, Injector, Injectable, AfterViewInit } from '@angular/core';
import { EventManager } from '../../../../src/app/core';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({ providedIn: 'any' })
export abstract class EditComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() queryParams: any = {};
  editForm: any;
  id: any;
  detailObject: any = {};
  errors: any = {};
  isSaved: boolean = false;
  isCall: boolean = false;
  subscriptions?: Subscription[] = [];
  subsCommon?: Subscription[] = [];
  calculateChange$ = new Subject();
  callApi$ = new Subject();
  constructor(
    public eventManager: EventManager,
    public route: ActivatedRoute
  ) {
  }
  ngOnInit() {
    const params = this.route.snapshot.params;
    this.id = params.id;
    if (this.id) {
      this.getDetail();
    }
    this.subsCommon = [
      this.calculateChange$.pipe(
        debounceTime(1000),
      ).subscribe((event)=> { return this.calculateTotal();}),
      this.callApi$.pipe(
        debounceTime(500),
        ).subscribe((event)=> { return this.callAPI(event);})
    ];
  }
  ngAfterViewInit(): void {
  }
  ngOnDestroy() {
    if (this.subscriptions.length > 0) {
      this.eventManager.destroys(this.subscriptions);
    }
  }
  getDetail() {}
  onSuccess(res) {}
  onError(error) {}
  updateForm() {}
  calculateTotal() {}
  callAPI(event?) {
    this.save();
  }
  execute() {
    this.executeCallAPI();
  }
  executeCallAPI(event?) {
    this.callApi$.next(event || true);
  }
  patchValue(field, value) {
    const body: any = {};
    body[field] = value;
    this.editForm.patchValue(body);
  }
  disabledButton() {
    const keys = Object.keys(this.errors);
    const key = keys.find(key => this.errors[key]);
    return key ? true : false;
  }
  save() {
    this.isSaved =  true;
    if (this.disabledButton()) {
      return;
    }
  }
}
